import React from "react";
import ReactDOM from "react-dom/client";
import "@iibf/shared-resources/assets/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

declare global {
  interface BigInt {
    toJSON: () => number;
  }
}

BigInt.prototype.toJSON = function () {
  return Number(this);
};
